export default "__VITE_ASSET__BwGLBr93__"